<template>
  <div>
    <Card>
      <ui-radio-group v-model="option" label="Simple radio group">
        <ui-radio label="First option" value="1"></ui-radio>
        <ui-radio label="Second option" value="2"></ui-radio>
      </ui-radio-group>
    </Card>
    <Card>
      <ui-radio-group v-model="option" label="Simple radio group" styleType="horizontal-line">
        <ui-radio label="First option" value="1"></ui-radio>
        <ui-radio label="Second option" value="2"></ui-radio>
      </ui-radio-group>
    </Card>
    <Card>
      <ui-radio-group :disabled="true" v-model="option" label="Simple radio group">
        <ui-radio label="First option" value="1"></ui-radio>
        <ui-radio label="Second option" value="2"></ui-radio>
      </ui-radio-group>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { ref } from 'vue';

const option = ref('1');
</script>
